import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { translator } from 'mage-i18n'
import { constants as notificationsConstants } from 'mage-notifications'

import {
  constants,
  AlertBannerError,
  AlertBannerWarning,
  AlertBannerSuccess
} from 'mage-deps/@klarna/bubble-ui'

const styleSheet = {
  base: {
    position: 'relative',
    top: -(constants.Grid.SIZE - 1)
  }
}

const getAlertBannerByLevel = (level) => {
  switch (level) {
    case notificationsConstants.NOTIFICATION_LEVELS.ERROR:
      return AlertBannerError
    case notificationsConstants.NOTIFICATION_LEVELS.SUCCESS:
      return AlertBannerSuccess
    case notificationsConstants.NOTIFICATION_LEVELS.WARNING:
    default:
      return AlertBannerWarning
  }
}

const AlertBanner = ({ t, level, tPath, tFallback, icon = true }) => {
  const AlertComponent = getAlertBannerByLevel(level)
  return (
    <div style={styleSheet.base}>
      <AlertComponent content={t(tPath, {}, tFallback)} icon={icon} />
    </div>
  )
}

AlertBanner.propTypes = {
  icon: PropTypes.bool,
  level: PropTypes.oneOf(
    Object.values(notificationsConstants.NOTIFICATION_LEVELS)
  ).isRequired,
  t: PropTypes.func.isRequired,
  tPath: PropTypes.string.isRequired,
  tFallback: PropTypes.string
}

export default connect(
  state => ({
    t: translator(state)
  })
)(AlertBanner)
